export default function PublicCibleSection() {
  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Titre principal */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3D2817] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            À qui s'adresse cette formation ?
          </h2>
          <p className="text-xl text-[#6B6B6B] max-w-3xl mx-auto leading-relaxed" style={{ lineHeight: '1.8' }}>
            Une formation conçue pour deux usages complémentaires
          </p>
        </div>

        {/* Sous-titre explicatif */}
        <div className="bg-gradient-to-br from-[#FAF7F4] to-[#F0E8E0] rounded-2xl p-8 mb-12 text-center">
          <p className="text-lg text-[#3A3A3A] leading-relaxed max-w-4xl mx-auto" style={{ lineHeight: '1.9' }}>
            Cette formation a été pensée pour répondre à une réalité de terrain.
          </p>
        </div>

        {/* Deux cartes publics */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Carte Cavalières */}
          <div className="bg-gradient-to-br from-[#E8956F]/10 to-[#E8956F]/5 rounded-3xl p-10 border-2 border-[#E8956F]/20 hover:border-[#E8956F]/40 transition-all hover:shadow-xl">
            <div className="w-16 h-16 bg-gradient-to-br from-[#E8956F] to-[#D67D5A] rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-user-heart-line text-white text-4xl"></i>
            </div>
            
            <div className="flex items-start gap-3 mb-4">
              <div className="w-7 h-7 bg-[#E8956F] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#3D2817]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Pour les cavalières atteintes d'endométriose
              </h3>
            </div>

            <p className="text-[#3A3A3A] leading-relaxed text-base mb-6" style={{ lineHeight: '1.9' }}>
              Qui souhaitent continuer à monter à cheval malgré la douleur, retrouver plus de confort, de mobilité et préserver leur relation avec leur cheval grâce à une méthode concrète de gestion de la douleur.
            </p>

            <div className="bg-white/60 rounded-xl p-5">
              <p className="text-sm text-[#6B6B6B] italic">
                Une méthode pour retrouver votre liberté à cheval et gérer la douleur au quotidien.
              </p>
            </div>
          </div>

          {/* Carte Professionnels */}
          <div className="bg-gradient-to-br from-[#3D2817]/10 to-[#3D2817]/5 rounded-3xl p-10 border-2 border-[#3D2817]/20 hover:border-[#3D2817]/40 transition-all hover:shadow-xl">
            <div className="w-16 h-16 bg-gradient-to-br from-[#3D2817] to-[#5A3F2A] rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-team-line text-white text-4xl"></i>
            </div>
            
            <div className="flex items-start gap-3 mb-4">
              <div className="w-7 h-7 bg-[#3D2817] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-lg"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#3D2817]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Pour les professionnels et accompagnants du monde équestre
              </h3>
            </div>

            <p className="text-[#6B6B6B] text-sm mb-4 italic">
              (sophrologues, préparateurs mentaux, enseignants, coachs, consultantes…)
            </p>

            <p className="text-[#3A3A3A] leading-relaxed text-base mb-6" style={{ lineHeight: '1.9' }}>
              Qui souhaitent se former à une approche spécifique et efficace pour accompagner les cavalières atteintes d'endométriose, avec des outils adaptés à la pratique équestre.
            </p>

            <div className="bg-white/60 rounded-xl p-5">
              <p className="text-sm text-[#6B6B6B] italic">
                Des outils professionnels pour accompagner efficacement vos clientes cavalières.
              </p>
            </div>
          </div>
        </div>

        {/* Encart conclusion */}
        <div className="bg-gradient-to-r from-[#3D2817] to-[#5A3F2A] rounded-2xl p-10 text-center shadow-2xl">
          <div className="max-w-3xl mx-auto">
            <h4 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Une même formation, deux applications possibles
            </h4>
            <p className="text-lg text-white/90 leading-relaxed" style={{ lineHeight: '1.9' }}>
              Pour soi ou pour accompagner, avec une méthode spécialement développée pour les cavalières.
            </p>
            
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <i className="ri-heart-pulse-line text-[#E8956F] text-xl"></i>
                <span className="text-white font-medium">Usage personnel</span>
              </div>
              <div className="text-white text-2xl">+</div>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <i className="ri-briefcase-line text-[#E8956F] text-xl"></i>
                <span className="text-white font-medium">Usage professionnel</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
